import { GapChaseFilterBase, filterType, dataType } from '../GapChaseFilterBase';

export default class ChaseInclusionListsFilter extends GapChaseFilterBase {
    constructor(chaseFilterData) {
        super();
        this.id = 21;
        this.name = "Chase Inclusion List";
        this.filterName = "ChaseInclusionLists";
        // this.isHidden = false;
        this.filterType = filterType.multiSelect;
        this.values = [];
        if (chaseFilterData.ChaseIncExNames !== null && chaseFilterData.ChaseIncExNames !== "undefined")
            this.values = chaseFilterData.ChaseIncExNames;

        this.dataType = dataType.number;
        this.filterCategory = "Member Level";
        this.filterGroupId = 3;
        this.placeholder = "Chase Inclusion List";
    }
}
